// removed by extract-text-webpack-plugin
module.exports = {"actions":"style_actions--2kBzYjsG"};


//////////////////
// WEBPACK FOOTER
// ./components/book-appointment/src/styles/style.scss
// module id = 644
// module chunks = 0